// preloader js
window.addEventListener('load', function () {
  const preloader = document.getElementById('global-preloader');
  if (!preloader) return;

  preloader.classList.add('is-hidden');

  preloader.addEventListener(
    'transitionend',
    () => {
      preloader.style.display = 'none';
    },
    { once: true }
  );
});

// HobbsGo on Wheels floating badge
(function () {
  // Don't show on the wheels page itself
  if (window.location.pathname.includes('hobbsgo-on-wheels')) return;
  // Dismiss for session if user closed it
  if (sessionStorage.getItem('how-badge-dismissed') === '1') return;

  /* HobbsGo On Wheels truck SVG - traced from the actual vehicle.
     Dark charcoal-purple body, open store section with fairy lights,
     4 pet faces, HobbsGo signage, India's First Pet Food Truck branding. */
  var vanSVG = `<svg class="how-badge__van-svg" viewBox="0 0 280 160" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <!-- HobbsGo signage bar (top of store section) -->
    <rect x="8" y="9" width="122" height="20" rx="6" fill="#573579"/>
    <circle cx="22" cy="19" r="7" fill="#7a52a5" stroke="#a17fc5" stroke-width="1.5"/>
    <text x="22" y="23" text-anchor="middle" font-family="Arial,sans-serif" font-size="8" font-weight="900" fill="white">H</text>
    <text x="82" y="23" text-anchor="middle" font-family="Arial,sans-serif" font-size="8.5" font-weight="900" fill="white" letter-spacing="1.5">HOBBSGO</text>
    <!-- Main truck body (store section) -->
    <rect x="8" y="27" width="192" height="78" rx="8" fill="#1e1030"/>
    <!-- Store interior -->
    <rect x="12" y="31" width="106" height="70" rx="4" fill="#130b20"/>
    <!-- Purple shelf rails -->
    <rect x="14" y="51" width="102" height="3" rx="1" fill="#4a2575"/>
    <rect x="14" y="66" width="102" height="3" rx="1" fill="#4a2575"/>
    <rect x="14" y="80" width="102" height="3" rx="1" fill="#4a2575"/>
    <!-- Products on top shelf (colorful packs) -->
    <rect x="16" y="41" width="9" height="10" rx="1" fill="#e53935" opacity="0.9"/>
    <rect x="27" y="41" width="9" height="10" rx="1" fill="#f57f17" opacity="0.9"/>
    <rect x="38" y="41" width="9" height="10" rx="1" fill="#2e7d32" opacity="0.9"/>
    <rect x="49" y="41" width="9" height="10" rx="1" fill="#1565c0" opacity="0.9"/>
    <rect x="60" y="41" width="9" height="10" rx="1" fill="#6a1b9a" opacity="0.9"/>
    <rect x="71" y="41" width="9" height="10" rx="1" fill="#c62828" opacity="0.9"/>
    <rect x="82" y="41" width="9" height="10" rx="1" fill="#00695c" opacity="0.9"/>
    <rect x="93" y="41" width="9" height="10" rx="1" fill="#f57f17" opacity="0.9"/>
    <!-- Products on second shelf -->
    <rect x="16" y="55" width="12" height="10" rx="1" fill="#5d4037" opacity="0.9"/>
    <rect x="30" y="55" width="12" height="10" rx="1" fill="#e53935" opacity="0.9"/>
    <rect x="44" y="55" width="12" height="10" rx="1" fill="#1565c0" opacity="0.9"/>
    <rect x="58" y="55" width="12" height="10" rx="1" fill="#2e7d32" opacity="0.9"/>
    <rect x="72" y="55" width="12" height="10" rx="1" fill="#f57f17" opacity="0.9"/>
    <rect x="86" y="55" width="12" height="10" rx="1" fill="#6a1b9a" opacity="0.9"/>
    <!-- Pet faces row (tabby cat, golden dog, grey cat, black lab) -->
    <rect x="12" y="83" width="106" height="12" rx="2" fill="#0d0818"/>
    <circle cx="29" cy="89" r="5.5" fill="#b8860b"/>
    <ellipse cx="25.5" cy="84.5" rx="2" ry="2.5" fill="#9a7010"/>
    <ellipse cx="32.5" cy="84.5" rx="2" ry="2.5" fill="#9a7010"/>
    <circle cx="27.5" cy="88" r="1" fill="#111"/><circle cx="30.5" cy="88" r="1" fill="#111"/>
    <ellipse cx="29" cy="91" rx="1.5" ry="1" fill="#d4607a"/>
    <circle cx="51" cy="89" r="5.5" fill="#d4a017"/>
    <ellipse cx="47" cy="84" rx="2.5" ry="3" fill="#c08c10"/>
    <ellipse cx="55" cy="84" rx="2.5" ry="3" fill="#c08c10"/>
    <circle cx="49" cy="88" r="1.2" fill="#111"/><circle cx="53" cy="88" r="1.2" fill="#111"/>
    <ellipse cx="51" cy="91" rx="2" ry="1.2" fill="#d4607a"/>
    <circle cx="73" cy="89" r="5.5" fill="#90a4ae"/>
    <ellipse cx="69.5" cy="84.5" rx="2" ry="2.5" fill="#78909c"/>
    <ellipse cx="76.5" cy="84.5" rx="2" ry="2.5" fill="#78909c"/>
    <circle cx="71.5" cy="88" r="1" fill="#111"/><circle cx="74.5" cy="88" r="1" fill="#111"/>
    <ellipse cx="73" cy="91" rx="1.5" ry="1" fill="#d4607a"/>
    <circle cx="95" cy="89" r="5.5" fill="#2d2d2d"/>
    <ellipse cx="91" cy="84" rx="3" ry="3.5" fill="#1a1a1a"/>
    <ellipse cx="99" cy="84" rx="3" ry="3.5" fill="#1a1a1a"/>
    <circle cx="93" cy="88" r="1.2" fill="#555"/><circle cx="97" cy="88" r="1.2" fill="#555"/>
    <ellipse cx="95" cy="91" rx="2" ry="1.5" fill="#b71c1c"/>
    <!-- "India's First Pet Food Truck" panel -->
    <rect x="119" y="76" width="79" height="29" rx="4" fill="#0d0818"/>
    <text x="158.5" y="88" text-anchor="middle" font-family="Arial,sans-serif" font-size="5.5" font-weight="900" fill="white">INDIA'S FIRST</text>
    <text x="158.5" y="98" text-anchor="middle" font-family="Arial,sans-serif" font-size="5" font-weight="700" fill="#a17fc5">PET FOOD TRUCK</text>
    <!-- Store body border -->
    <rect x="8" y="27" width="192" height="78" rx="8" fill="none" stroke="#3d2565" stroke-width="1.5"/>
    <!-- Fairy lights wire -->
    <path d="M10 29 Q20 35 30 29 Q40 35 50 29 Q60 35 70 29 Q80 35 90 29 Q100 35 110 29 Q120 35 130 29 Q140 35 150 29 Q160 35 170 29 Q180 35 190 29 Q197 33 200 29" stroke="#c8a000" stroke-width="1.2" fill="none"/>
    <!-- Light bulbs -->
    <ellipse cx="30" cy="36" rx="2.5" ry="3.5" fill="#fff176"/><circle cx="30" cy="35" r="2" fill="#ffee58"/>
    <ellipse cx="50" cy="36" rx="2.5" ry="3.5" fill="#fff176"/><circle cx="50" cy="35" r="2" fill="#ffee58"/>
    <ellipse cx="70" cy="36" rx="2.5" ry="3.5" fill="#fff176"/><circle cx="70" cy="35" r="2" fill="#ffee58"/>
    <ellipse cx="90" cy="36" rx="2.5" ry="3.5" fill="#fff176"/><circle cx="90" cy="35" r="2" fill="#ffee58"/>
    <ellipse cx="110" cy="36" rx="2.5" ry="3.5" fill="#fff176"/><circle cx="110" cy="35" r="2" fill="#ffee58"/>
    <ellipse cx="130" cy="36" rx="2.5" ry="3.5" fill="#fff176"/><circle cx="130" cy="35" r="2" fill="#ffee58"/>
    <ellipse cx="150" cy="36" rx="2.5" ry="3.5" fill="#fff176"/><circle cx="150" cy="35" r="2" fill="#ffee58"/>
    <ellipse cx="170" cy="36" rx="2.5" ry="3.5" fill="#fff176"/><circle cx="170" cy="35" r="2" fill="#ffee58"/>
    <ellipse cx="190" cy="36" rx="2.5" ry="3.5" fill="#fff176"/><circle cx="190" cy="35" r="2" fill="#ffee58"/>
    <!-- Cab section -->
    <path d="M198 27 L260 27 Q270 27 272 38 L272 105 L198 105 Z" fill="#130b20"/>
    <!-- Windshield -->
    <rect x="204" y="33" width="52" height="40" rx="5" fill="#4a8db5" opacity="0.65"/>
    <path d="M207 36 L244 36 L240 46 L207 46 Z" fill="white" opacity="0.1"/>
    <!-- Cab window small -->
    <rect x="202" y="76" width="24" height="16" rx="2" fill="#4a8db5" opacity="0.45"/>
    <!-- Cab door panel -->
    <rect x="199" y="74" width="71" height="31" rx="2" fill="#130b20" stroke="#2d1b45" stroke-width="1"/>
    <!-- Front grille -->
    <rect x="264" y="58" width="12" height="26" rx="3" fill="#2d1b45"/>
    <rect x="266" y="61" width="8" height="3" rx="1" fill="#1e1030"/>
    <rect x="266" y="67" width="8" height="3" rx="1" fill="#1e1030"/>
    <rect x="266" y="73" width="8" height="3" rx="1" fill="#1e1030"/>
    <!-- Headlight -->
    <rect x="265" y="34" width="11" height="9" rx="2" fill="#fff9c4" opacity="0.85"/>
    <!-- Purple accent strip -->
    <rect x="8" y="101" width="264" height="5" rx="2" fill="#7a52a5"/>
    <!-- Chassis -->
    <rect x="8" y="105" width="264" height="7" rx="3" fill="#0d0818"/>
    <!-- Rear wheel -->
    <circle cx="60" cy="120" r="19" fill="#0d0818"/>
    <circle cx="60" cy="120" r="13" fill="#2d2d3f"/>
    <circle cx="60" cy="120" r="7" fill="#444"/>
    <circle cx="60" cy="120" r="2.5" fill="#aaa"/>
    <line x1="60" y1="107" x2="60" y2="133" stroke="#333" stroke-width="1.8"/>
    <line x1="47" y1="120" x2="73" y2="120" stroke="#333" stroke-width="1.8"/>
    <line x1="51" y1="111" x2="69" y2="129" stroke="#333" stroke-width="1.4"/>
    <line x1="51" y1="129" x2="69" y2="111" stroke="#333" stroke-width="1.4"/>
    <!-- Front wheel -->
    <circle cx="220" cy="120" r="19" fill="#0d0818"/>
    <circle cx="220" cy="120" r="13" fill="#2d2d3f"/>
    <circle cx="220" cy="120" r="7" fill="#444"/>
    <circle cx="220" cy="120" r="2.5" fill="#aaa"/>
    <line x1="220" y1="107" x2="220" y2="133" stroke="#333" stroke-width="1.8"/>
    <line x1="207" y1="120" x2="233" y2="120" stroke="#333" stroke-width="1.8"/>
    <line x1="211" y1="111" x2="229" y2="129" stroke="#333" stroke-width="1.4"/>
    <line x1="211" y1="129" x2="229" y2="111" stroke="#333" stroke-width="1.4"/>
    <!-- Bumpers -->
    <rect x="4" y="96" width="10" height="12" rx="3" fill="#2d1b45"/>
    <rect x="270" y="92" width="10" height="16" rx="3" fill="#2d1b45"/>
    <!-- Motion smoke puffs (truck moving) -->
    <circle cx="3" cy="108" r="4" fill="#3d2565" opacity="0.25"/>
    <circle cx="-3" cy="104" r="5" fill="#3d2565" opacity="0.15"/>
    <circle cx="-9" cy="100" r="6" fill="#3d2565" opacity="0.1"/>
  </svg>`;

  /* Smaller version for card banner - same truck, white/transparent fills for dark purple bg */
  var vanSmallSVG = `<svg class="how-badge__card-banner-van" viewBox="0 0 280 160" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <rect x="8" y="9" width="122" height="20" rx="6" fill="rgba(255,255,255,0.2)"/>
    <text x="82" y="23" text-anchor="middle" font-family="Arial,sans-serif" font-size="8.5" font-weight="900" fill="white" letter-spacing="1.5">HOBBSGO</text>
    <rect x="8" y="27" width="192" height="78" rx="8" fill="rgba(255,255,255,0.15)"/>
    <rect x="12" y="31" width="106" height="70" rx="4" fill="rgba(0,0,0,0.2)"/>
    <rect x="14" y="51" width="102" height="3" rx="1" fill="rgba(255,255,255,0.2)"/>
    <rect x="14" y="66" width="102" height="3" rx="1" fill="rgba(255,255,255,0.2)"/>
    <path d="M10 29 Q20 35 30 29 Q40 35 50 29 Q60 35 70 29 Q80 35 90 29 Q100 35 110 29 Q120 35 130 29 Q140 35 150 29 Q160 35 170 29 Q180 35 190 29" stroke="#fff9c4" stroke-width="1.2" fill="none"/>
    <circle cx="30" cy="34" r="2.5" fill="#fff9c4" opacity="0.9"/>
    <circle cx="70" cy="34" r="2.5" fill="#fff9c4" opacity="0.9"/>
    <circle cx="110" cy="34" r="2.5" fill="#fff9c4" opacity="0.9"/>
    <circle cx="150" cy="34" r="2.5" fill="#fff9c4" opacity="0.9"/>
    <circle cx="190" cy="34" r="2.5" fill="#fff9c4" opacity="0.9"/>
    <path d="M198 27 L260 27 Q270 27 272 38 L272 105 L198 105 Z" fill="rgba(0,0,0,0.25)"/>
    <rect x="204" y="33" width="52" height="40" rx="5" fill="rgba(255,255,255,0.35)"/>
    <rect x="8" y="101" width="264" height="5" rx="2" fill="rgba(255,255,255,0.3)"/>
    <circle cx="60" cy="120" r="19" fill="rgba(0,0,0,0.35)"/>
    <circle cx="60" cy="120" r="8" fill="rgba(255,255,255,0.2)"/>
    <circle cx="220" cy="120" r="19" fill="rgba(0,0,0,0.35)"/>
    <circle cx="220" cy="120" r="8" fill="rgba(255,255,255,0.2)"/>
  </svg>`;

  var badge = document.createElement('div');
  badge.className = 'how-badge';
  badge.setAttribute('role', 'complementary');
  badge.setAttribute('aria-label', 'HobbsGo on Wheels offers');
  badge.innerHTML = `
    <div class="how-badge__card" id="how-badge-card" hidden>
      <div class="how-badge__card-banner">
        ${vanSmallSVG}
        <div class="how-badge__card-banner-text">
          <p class="how-badge__card-title">HobbsGo on Wheels 🐾</p>
          <p class="how-badge__card-sub">We're parked near you - visit us today!</p>
        </div>
        <button class="how-badge__card-close" id="how-badge-close" aria-label="Close">✕</button>
      </div>
      <div class="how-badge__card-body">
        <div class="how-badge__loc">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
          Gomti Nagar, Lucknow
        </div>
        <div class="how-badge__offers">
          <div class="how-badge__offer-row">
            <span class="how-badge__tag how-badge__tag--purple">20% OFF</span>
            Accessories &amp; Treats
          </div>
          <div class="how-badge__offer-row">
            <span class="how-badge__tag how-badge__tag--teal">15% OFF</span>
            Dry &amp; Wet Food
          </div>
          <div class="how-badge__offer-row">
            <span class="how-badge__tag how-badge__tag--gold">500 PTS</span>
            On orders over ₹1,000
          </div>
        </div>
        <a href="/pages/hobbsgo-on-wheels-indias-first-pet-food-truck" class="how-badge__cta">See All Offers &amp; Location →</a>
      </div>
    </div>
    <button class="how-badge__trigger" id="how-badge-trigger" aria-expanded="false" aria-label="HobbsGo on Wheels - view offers and location">
      ${vanSVG}
      <span class="how-badge__pulse" aria-hidden="true"></span>
    </button>
    <div class="how-badge__tooltip" aria-hidden="true">🐾 We're nearby!</div>
  `;

  document.body.appendChild(badge);

  var trigger   = document.getElementById('how-badge-trigger');
  var card      = document.getElementById('how-badge-card');
  var closeBtn  = document.getElementById('how-badge-close');

  function openCard() {
    card.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');
    badge.classList.add('how-badge--open');
  }
  function closeCard() {
    card.hidden = true;
    trigger.setAttribute('aria-expanded', 'false');
    badge.classList.remove('how-badge--open');
  }

  trigger.addEventListener('click', function () {
    card.hidden ? openCard() : closeCard();
  });

  closeBtn.addEventListener('click', function (e) {
    e.stopPropagation();
    sessionStorage.setItem('how-badge-dismissed', '1');
    badge.remove();
  });

  // Close on outside click
  document.addEventListener('click', function (e) {
    if (!badge.contains(e.target)) closeCard();
  });

  // Auto-open once after 4 seconds on first visit (this session)
  if (!sessionStorage.getItem('how-badge-seen')) {
    setTimeout(function () {
      openCard();
      sessionStorage.setItem('how-badge-seen', '1');
    }, 4000);
  }
})();

// Infinite scroll pagination (auto-loads next page as user scrolls near bottom)
document.addEventListener("DOMContentLoaded", () => {
  const btn = document.querySelector("#load-more");
  if (!btn) return;

  const productGrid = document.querySelector("#product-grid");
  const articleGrid = document.querySelector("#article-grid");

  const grid = productGrid || articleGrid;
  if (!grid) return;

  const itemSelector = productGrid
    ? "#product-grid > li"
    : "#article-grid > .blog-articles__article";

  let loading = false;

  const stripAnimationClasses = (root) => {
    root.querySelectorAll(".scroll-trigger, .scroll-trigger--offscreen").forEach((el) => {
      el.classList.remove(
        "scroll-trigger",
        "scroll-trigger--offscreen",
        "animate--slide-in",
        "animate--fade-in",
        "scroll-trigger--cancel"
      );
      el.removeAttribute("data-cascade");
    });
  };
  stripAnimationClasses(grid);

  const loadNext = () => {
    if (loading || !btn.dataset.nextUrl) return;
    loading = true;
    btn.textContent = "Loading...";

    fetch(btn.dataset.nextUrl)
      .then((res) => res.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, "text/html");
        const newItems = doc.querySelectorAll(itemSelector);
        newItems.forEach((item) => {
          item.classList.remove(
            "scroll-trigger",
            "scroll-trigger--offscreen",
            "animate--slide-in",
            "animate--fade-in",
            "scroll-trigger--cancel"
          );
          item.removeAttribute("data-cascade");
          item.removeAttribute("style");
          grid.appendChild(item);
        });

        const nextBtn = doc.querySelector("#load-more");
        if (nextBtn && nextBtn.dataset.nextUrl) {
          btn.dataset.nextUrl = nextBtn.dataset.nextUrl;
          btn.textContent = "Load More";
        } else {
          if (observer) observer.disconnect();
          btn.remove();
        }
        loading = false;
      })
      .catch(() => {
        btn.textContent = "Load More";
        loading = false;
      });
  };

  btn.addEventListener("click", loadNext);

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) loadNext();
      });
    },
    { rootMargin: "600px 0px" }
  );
  observer.observe(btn);
});


/* ============================================================
   <variant-pills-card> — HobbsGo product card variant switcher.
   Updates price, compare-at, discount badge, and the hidden
   variant-id input inline on the PLP / sliders / search / etc.
   No page reload; keeps Dawn's <product-form> submission intact.
   ============================================================ */
class VariantPillsCard extends HTMLElement {
  connectedCallback() {
    if (this._wired) return;
    this._wired = true;
    this.pills = this.querySelectorAll('.hg-pill');
    if (!this.pills.length) return;
    this.priceEl   = this.querySelector('[data-hg-price]');
    this.compareEl = this.querySelector('[data-hg-compare]');
    this.percentEl = this.querySelector('[data-hg-percent]');
    this.inputEl   = this.querySelector('[data-hg-variant-input]');
    this.atcEl     = this.querySelector('[data-hg-atc]');
    // Badge stays static (shows max % across variants). Not touched here.
    this.pills.forEach((pill) => {
      pill.addEventListener('click', (e) => {
        e.preventDefault();
        if (pill.classList.contains('is-selected')) return;
        this.select(pill);
      });
    });
  }

  select(pill) {
    this.pills.forEach((p) => {
      p.classList.remove('is-selected');
      p.setAttribute('aria-checked', 'false');
    });
    pill.classList.add('is-selected');
    pill.setAttribute('aria-checked', 'true');

    const variantId  = pill.dataset.variantId;
    const price      = pill.dataset.variantPrice;
    const compare    = pill.dataset.variantCompare || '';
    const percent    = pill.dataset.variantPercent || '';
    const available  = pill.dataset.variantAvailable === 'true';

    if (this.priceEl && price) this.priceEl.innerHTML = price;

    this._toggle(this.compareEl, compare);
    this._toggle(this.percentEl, percent ? percent + '% off' : '');

    if (this.inputEl) {
      this.inputEl.value = variantId;
      this.inputEl.disabled = !available;
    }
    if (this.atcEl) {
      this.atcEl.disabled = !available;
      const label = this.atcEl.querySelector('span');
      if (label) label.textContent = available ? 'Add to Cart' : 'Sold Out';
    }
  }

  _toggle(el, value) {
    if (!el) return;
    if (value) {
      el.innerHTML = value;
      el.hidden = false;
    } else {
      el.innerHTML = '';
      el.hidden = true;
    }
  }
}

if (!customElements.get('variant-pills-card')) {
  customElements.define('variant-pills-card', VariantPillsCard);
}


